// src/services/companyDailyDeckService.js
//
// The free tier's provider deck. Premium groups never call this; they get the
// full deck through matchingService.browseProviders.

import api from '../api';
import { handleApiError } from '../utils/errorHandler';

const companyDailyDeckService = {
  /** A server-computed range only; the exact pool size is never sent. */
  getMatchPool: async () => {
    const response = await api.get('/company/match-pool');
    return response.data;
  },
  /**
   * Today's curated matches for the caller's group.
   *
   * Returns { deckDate, nextRefreshAt, cap, exhausted, matches[] }, where each
   * match carries { providerProfileId, matchScore, card, listing }.
   *
   * `peek: true` is for background reads (a count, a prefetch) that no person
   * is looking at. It sends ?peek=1 so the server can distinguish that read;
   * Premium activation is handled only at eligible signup. The payload is the
   * same. With no options the request is the plain one it has always been.
   */
  getDailyDeck: async ({ peek = false } = {}) => {
    try {
      const response = peek
        ? await api.get('/company/daily-matches', { params: { peek: '1' } })
        : await api.get('/company/daily-matches');
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Failed to load your daily matches');
    }
  },
};

export default companyDailyDeckService;
